import { Navigate, Route, Routes as RoutesDom } from 'react-router-dom';
import { CompanyRoutes } from './company/routes';
import { UserRoutes } from './user/routes';
import { AgencyRoutes } from './agency/routes';
import { CampaignRoutes } from './campaigns/routes';
import { OfferRoutes } from './offer/routes';
import { OfferPdfRoutes } from './offer-pdf/routes';
import { OfferEventTransferRoutes } from './offer-event-transfer/routes';
import { ContractPdfRoutes } from './contract-pdf/routes';
import { StatisticsRoutes } from './statistics/routes';
import { Dashboard } from './dashboard/components/Dashboard';
import { PlatformRoutes } from './platform/routes';
import { ExportRoutes } from './export/routes';
import PackagesRoutes from './packages/routes';
import { InvoiceRoutes } from './invoices/routes';
import { SupervisorRoutes } from './supervisors/routes';
import { OnboardingRequests } from './onboarding-requests/routes';
import { AccessRightRoutes } from './access-right/routes';
import { AdminRoutes } from './admins/routes';
import { ContractRoutes } from './contract/routes';
import { DiscoveryRoutes } from './discovery/routes';
// import { ContentRoute } from '../shared/layout';
import { ReportingRoutes } from './reporting/routes';
import { ModashRoutes } from './modash/routes';
import { DiscoveryFilterRoutes } from './discovery-filters/routes';
import ControllingRoutes from './controlling/routes';
import {BrandAccessRoutes} from './brand-access-right/routes';

export default function AppRoutes() {
    return (
        <RoutesDom>
            <Route path="/" element={<Dashboard />} />

            <Route path="/user/*" element={<UserRoutes />} />

            <Route path="/agency/*" element={<AgencyRoutes />} />

            <Route path="/campaign/*" element={<CampaignRoutes />} />

            <Route path="/offers/*" element={<OfferRoutes />} />

            <Route path="/offer-pdfs/*" element={<OfferPdfRoutes />} />

            <Route path="/offer-event-transfer/*" element={<OfferEventTransferRoutes />} />

            <Route path="/contract-pdfs/*" element={<ContractPdfRoutes />} />

            <Route path="/reporting/*" element={<ReportingRoutes />} />

            <Route path="/statistics/*" element={<StatisticsRoutes />} />

            <Route path="/company/*" element={<CompanyRoutes />} />

            <Route path="/platform/*" element={<PlatformRoutes />} />

            <Route path="/export/*" element={<ExportRoutes />} />

            <Route path="/packages/*" element={<PackagesRoutes />} />

            <Route path="/controlling/*" element={<ControllingRoutes />} />

            <Route path="/invoices/*" element={<InvoiceRoutes />} />

            <Route path="/onboarding-requests/*" element={<OnboardingRequests />} />

            <Route path="/supervisors/*" element={<SupervisorRoutes />} />

            <Route path="/admins/*" element={<AdminRoutes />} />

            <Route path="/access-right/*" element={<AccessRightRoutes />} />

            <Route path="/brand-acess-rights/*" element={<BrandAccessRoutes />} />

            <Route path="/contracts/*" element={<ContractRoutes />} />

            <Route path="/discovery/*" element={<DiscoveryRoutes />} />

            <Route path="/modash/*" element={<ModashRoutes />} />

            <Route path="*" element={<Navigate to="/" replace />} />

            <Route path="/discovery-preset/*" element={<DiscoveryFilterRoutes />} />

            {/*<Route>*/}
            {/*    <PartnerRoutes/>*/}
            {/*</Route>*/}
        </RoutesDom>
    );
}
